import { Component } from "@angular/core";
import {
  ViewController,
  AlertController,
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  Events,
} from "ionic-angular";
import { HttpClient } from "../../../../services/HttpClient";
import { CustomToast } from "../../../../util/CustomToast";

import { ImageSelector } from "../../../../util/imageSelector/imageSelector";

import { UserPublicationsPage } from "./publications/publications";

@Component({
  selector: "page-user",
  templateUrl: "user.html",
  providers: [HttpClient, CustomToast],
})
export class UserPage {
  private me;
  private user;
  private researchlines;
  private persontypes;
  private groups;

  private rentals;
  private chosenRentals;
  private active = false;
  private oldMember = false;

  private viewCtrl: ViewController;
  private navCtrl: NavController;
  private navParams: NavParams;
  private httpClient: HttpClient;
  private baseUrl;
  private loadingCtrl: LoadingController;
  private alertCtrl: AlertController;
  private modalCtrl: ModalController;
  private customToast: CustomToast;

  private newpassword = "";
  private newpassword2 = "";

  private loading;

  private image = {
    id: -1,
    filename: "addimage.png",
  };

  private idUser;


  constructor(
    viewCtrl: ViewController,
    alertCtrl: AlertController,
    navCtrl: NavController,
    navParams: NavParams,
    httpClient: HttpClient,
    loadingCtrl: LoadingController,
    modalCtrl: ModalController,
    customToast: CustomToast,
    public events: Events
  ) {
    this.viewCtrl = viewCtrl;
    this.navParams = navParams;
    this.navCtrl = navCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    this.loadingCtrl = loadingCtrl;
    this.alertCtrl = alertCtrl;
    this.modalCtrl = modalCtrl;
    this.customToast = customToast;

    this.init();

    var id = this.navParams.get("id");
    this.idUser = id;
    this.httpCallMe();
    this.httpCallUser(id);
    this.httpCallResearchLines();
    this.httpCallPersonTypes();
    this.httpCallRentals();
    this.httpCallManagedRentals(id);
    this.httpCallGroups();
  }

  init() {
    this.user = {
      name: null,
      surname1: null,
      surname2: null,
      username: null,
      image: null,
      phone: null,
      email: null,
      category_es: null,
      category_en: null,
      extension: null,
      institution: null,
      researcherid: null,
      google_scholar: null,
      external_link: null,
      research_line_id: null,
      person_type_id: null,
      summary_es: null,
      summary_en: null,
      orcid: null,
      scopus: null,
      tags_es: null,
      tags_en: null,
      active: false,
      oldMember: false,
      bookings_role: null,
      group_id: -1,
    };
    this.rentals = [{}];
    this.chosenRentals = [];
  }

  httpCallMe() {
    this.httpClient.get("/users/me", (error, data) => {
      this.me = data.json();
    });
  }

  httpCallUser(id) {
    this.httpClient.get("/users/" + id, (error, data) => {
      if (!error) {
        this.user = data.json();
        this.active = this.user.active ? true : false;
        this.oldMember = this.user.oldMember ? true : false;
        if (this.user.image) {
          this.image.filename = this.user.image;
        }
      }
    });
  }

  httpCallResearchLines() {
    this.httpClient.get("/researchlines", (error, data) => {
      if (!error) {
        this.researchlines = data.json();
      }
    });
  }

  httpCallPersonTypes() {
    this.httpClient.get("/persontypes", (error, data) => {
      if (!error) {
        this.persontypes = data.json();
      }
    });
  }

  httpCallRentals() {
    this.httpClient.get("/rentals", (error, data) => {
      if (!error) {
        this.rentals = data.json();
      }
    });
  }

  httpCallManagedRentals(id) {
    this.httpClient.get(`/managers/rentals/${id}`, (error, data) => {
      if (!error) {
        this.chosenRentals = data.json();
      }
    });
  }

  httpCallGroups() {
    this.httpClient.get("/groups", (error, data) => {
      if (!error) {
        this.groups = data.json();
      }
    });
  }

  httpCallPutUser() {
    if (
      this.user.name &&
      this.user.surname1 &&
      this.user.role &&
      this.user.person_type_id
    ) {
      this.user.active = this.active == true ? 1 : 0;
      this.user.oldMember = this.oldMember == true ? 1 : 0;
      this.showLoading();
      this.httpClient.put(
        "/users/" + this.user.id,
        this.user,
        (error, data) => {
          if (!error) {
            this.hideLoading();
            this.dismiss(true);
          }
        }
      );
    } else {
      this.customToast.showMessage(
        "Alguno de los campos requeridos no ha sido rellenado o está vacío",
        8000
      );
    }
    this.user.bookings_role === "manager" &&
      this.httpClient.put(
        "/managers/" + this.user.id,
        this.chosenRentals,
        (error, data) => {
          if (error) {
            console.log(error);
          }
        }
      );
  }

  httpCallDeleteUser() {
    this.showLoading();
    this.httpClient.delete("/users/" + this.idUser, (error, result) => {
      this.hideLoading();
      this.events.publish("user:delete");
      this.dismiss(true);
    });
  }

  onClickImage() {
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss((image) => {
      if (image) {
        this.image = image;
        this.user.image = image.filename;
      }
    });
  }

  onClickPublications() {
    this.navCtrl.push(UserPublicationsPage, { idUser: this.idUser });
  }

  onClickDelete() {
    let alert = this.alertCtrl.create({
      title: "¿Estás seguro?",
      message: "Vas a ocultar el usuario en la plataforma",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.httpCallDeleteUser();
          },
        },
      ],
    });
    alert.present();
  }

  onClickSave() {
    let alert = this.alertCtrl.create({
      title: "¿Estás seguro?",
      message: "Vas a actualizar la información",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.checkGroupCoordinator();
          },
        },
      ],
    });
    alert.present();
  }

  checkGroupCoordinator() {
    
    let isCoordinator:boolean = false
    let isChangingGroup:boolean = false
    let coordinatingGroupId: number; 

    isCoordinator = this.groups.some(g =>{ 
      
      const condition = g.coordinator_id === this.user.id
      if (condition)
      {
    coordinatingGroupId= g.id 
    return true
      }
    })
    
    isChangingGroup = this.user.group_id != coordinatingGroupId;
    
    if(isCoordinator && isChangingGroup)
      this.customToast.showMessage(
        "Para cambiar de grupo debe dejar de ser coordinador del actual. Contacte con administración",
        2000
      );
    else{
      this.httpCallPutUser();
      }
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Guardando la información...",
    });
    this.loading.present();
  }

  hideLoading() {
    this.loading.dismiss();
  }

  dismiss(reload) {
    this.viewCtrl.dismiss(reload);
  }

  onClickChangePassword() {
    let alert = this.alertCtrl.create({
      title: "¿Estas seguro?",
      message: "Vas a cambiar la contraseña de este usuario",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.changePassword();
          },
        },
      ],
    });
    alert.present();
  }

  changePassword() {
    if (this.newpassword.length >= 6) {
      if (this.newpassword == this.newpassword2) {
        this.httpCallChangePassword(this.newpassword.trim());
      } else {
        this.customToast.showMessage("La contraseña no coincide", 4000);
      }
    } else {
      this.customToast.showMessage(
        "La contraseña debe tener al menos 6 caracteres",
        4000
      );
    }
  }

  httpCallChangePassword(newpassword) {
    this.httpClient.put(
      "/users/" + this.idUser + "/password",
      { newpassword: newpassword },
      (error, data) => {
        if (error) {
          this.customToast.showMessage(error, 4000);
        } else {
          this.clearInput();
          this.customToast.showMessage(
            "Contraseña actualizada correctamente",
            4000
          );
        }
      }
    );
  }

  clearInput() {
    this.newpassword = "";
    this.newpassword2 = "";
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/users/user/user.ts